<template>
    <div id="about-box">
      <BreadCrumb :title="'帮助中心'" />
      <div id="about">
        <aside class="side-bar">
          <ul>
            <li :class="{'side-item': true, active: 'Us' === this.curName}">
              <router-link to="/help/about.html">关于我们</router-link>
            </li>
            <li :class="{'side-item': true, active: 'Business' === this.curName}">
              <router-link to="/help/business.html">商务合作</router-link>
            </li>
            <li :class="{'side-item': true, active: 'Shoot' === this.curName}">
              <router-link to="/help/shoot.html">拍摄联系方式</router-link>
            </li>
            <li :class="{'side-item': true, active: 'Join' === this.curName}">
              <router-link to="/help/join.html">加入我们</router-link>
            </li>
            <li :class="{'side-item': true, active: 'Law' === this.curName}">
              <router-link to="/help/law.html">法律声明</router-link>
            </li>
            <li :class="{'side-item': true, active: 'Service' === this.curName}">
              <router-link to="/help/service.html">服务条款</router-link>
            </li>
            <li :class="{'side-item': true, active: 'Report' === this.curName}">
              <router-link to="/help/report.html">举报</router-link>
            </li>
          </ul>
        </aside>
        <main class="about-content">
          <router-view></router-view>
        </main>
      </div>
    </div>
</template>
<script>
  import BreadCrumb from '@/components/BreadCrumb'

  export default {
    name: 'About',
    components: { BreadCrumb },
    data () {
      return {
        curName: 'Us'
      }
    },
    created () {
      this.curName = this.$route.name
    },
    watch: {
      $route(to, from){
        if (from.name != to.name)  {
          this.curName = to.name;
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  #about-box {
    width: 980px;
    margin: 0 auto;
    padding: 40px 0;
  }
  #about {
    display: flex;
    font-size: 14px;
    padding: 20px 0 40px 0;
    .side-bar {
      width: 250px;
      background-color: white;
      border-right: solid 1px #f2f2f2;
      .side-item {
        padding: 15px 20px;
        font-weight: 500;
        a {
          color: #4A4A4A;
        }
      }
      .side-item:hover a {
        color: #F39;
      }
    }
    .about-content {
      flex: 1;
      background-color: white;
    }
  }
  .active {
    border-left: solid 2px #f39;
    a {
      color: #F39 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/About.vue